import { ProgramProfileClient } from './../../../../services/apis/web-api-client';
import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { forkJoin } from "rxjs";
import { ModalComponent } from '../modal/modal.component';
import { CategoriesOfListeners, CategoriesOfListenersClient, ConfirmationDocument, EducationalProgram, EducationForm, EntranceExam, EntranceExamClient, FileClient, Person, PersonClient, ProgramProfile, Section, SectionClient } from 'src/app/services/apis/web-api-client';
import { FileService } from 'src/app/services/file.service';
import { GetConfirmationDocumentType } from 'src/app/models/enums/confirmation-document';
import { GetEducationForms } from 'src/app/models/enums/education-form';

@Component({
  selector: 'app-program',
  templateUrl: './program.component.html',
  styleUrls: ['./program.component.scss']
})
export class ProgramComponent implements OnInit {
  list: any[] = [];
  isLoaded: boolean = true;
  item: EducationalProgram;
  entranceExamsLength: number;
  section: Section;
  programProfiles: Array<ProgramProfile> = [];
  programProfilesInProgram: Array<ProgramProfile> = [];
  categoryOfListnersList: Array<CategoriesOfListeners> = [];
  categoriesOfListnersInProgram: Array<CategoriesOfListeners> = [];
  exams: Array<EntranceExam> = [];
  examsInProgram: Array<EntranceExam> = [];
  modalRef: BsModalRef;
  modalRef2: BsModalRef;
  // person: Person;

  constructor(
    public bsModalRef2: BsModalRef,
    private modalService: BsModalService,
    private fileService: FileService,
    private categoriesOfListeners: CategoriesOfListenersClient,
    private personService: PersonClient,
    private entranceExamsService: EntranceExamClient,
    private sectionService: SectionClient,
    private programProfileService: ProgramProfileClient
  ) {
    this.modalRef2 = bsModalRef2;
  }

  ngOnInit() {
    this.item = this.list[0];
    console.log(this.item)
    this.entranceExamsLength = this.item.entranceExams.length;
    forkJoin({
      programProfiles: this.programProfileService.getAll(),
      cities: this.categoriesOfListeners.getAll(),
      section: this.sectionService.getOne(this.item.sectionId),
      exams: this.entranceExamsService.getAll(),
      // person: this.personService.getOne(this.item.personId)
    }).subscribe(value => {
      this.programProfiles = value.programProfiles;
      this.exams = value.exams;
      this.categoryOfListnersList = value.cities;
      this.section = value.section;
      // this.person = value.person;
      this.programProfilesInProgram = [];
      this.item.programProfiles.forEach(
        programProfileCut => {
          this.programProfiles.forEach(
            programProfileFull => {
              if (programProfileCut.programProfileId === programProfileFull.id) {
                this.programProfilesInProgram.push(programProfileFull);
              }
            }
          );
        }
      );


      this.categoriesOfListnersInProgram = [];
      this.item.categoriesOfListeners.forEach(
        cityCut => {
          this.categoryOfListnersList.forEach(
            response => {
              if (cityCut.categoriesOfListenersId === response.id) {
                this.categoriesOfListnersInProgram.push(response);
              }
            }
          );
        }
      );

      this.examsInProgram = [];
      this.item.entranceExams.forEach(
        examCut => {
          this.exams.forEach(
            examFull => {
              if (examCut.entranceExamId === examFull.id) {
                this.examsInProgram.push(examFull);
              }
            }
          );
        }
      );
      this.isLoaded = false;
    })
  }

  getExamName(id: string) {
    return this.exams.find(value => value.id == id).name;
  }
  getImage(link) {
    return this.fileService.getDownloadUrl(link);
  }


  getConfirmationDocumentType(type: ConfirmationDocument) {
    return GetConfirmationDocumentType(type);
  }

  getEducationForm(form: EducationForm) {
    return GetEducationForms(form);
  }


  openModal() {

    const initialState = {
      programId: this.item.id
    };
    this.modalService.show(ModalComponent, { initialState });

    this.modalService._hideModal(1)
  }

}
